import script from "./ResultPageView.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultPageView.vue?vue&type=script&setup=true&lang=js"

import "./ResultPageView.vue?vue&type=style&index=0&id=28268c46&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28268c46"]])

export default __exports__